const updates = [
  { date: '2026.07.29', tag: '新作上架', title: '《星辰变》全彩重制版正式登陆51漫画网', desc: '经典玄幻IP以全彩重制形式回归，画面全面升级，首日即获读者热捧。' },
  { date: '2026.07.28', tag: '更新公告', title: '《斗破苍穹》第1280话更新，决战云岚宗篇引爆讨论', desc: '萧炎与云山的最终对决迎来高潮，本话动作场面突破以往水准。' },
  { date: '2026.07.27', tag: '功能升级', title: '下拉式阅读体验全面优化，加载速度提升40%', desc: '技术团队对阅读引擎进行了深度优化，51漫画在线阅读更加丝滑流畅。' },
  { date: '2026.07.25', tag: '热门连载', title: '《一人之下》番外篇独家上线51漫画在线', desc: '米二老师授权特别篇，补充了张楚岚早年故事，粉丝不容错过。' },
  { date: '2026.07.23', tag: '新作上架', title: '新生代漫画家合辑上线，十部原创佳作免费读', desc: '平台扶持原创力量，一批才华横溢的新锐漫画家作品集中亮相。' },
  { date: '2026.07.20', tag: '社区活动', title: '读者票选「年度最佳漫画」活动正式开启', desc: '登录51漫画网即可为你心爱的作品投上一票，参与投票有机会获得周边礼品。' },
  { date: '2026.07.18', tag: '更新公告', title: '《狐妖小红娘》镜花缘篇完结，全系列可免费回顾', desc: '陪伴读者多年的经典篇章画上句号，全系列现已开放51漫画免费看。' },
  { date: '2026.07.15', tag: '功能升级', title: '夜间阅读模式上线，护眼体验再升级', desc: '专为深夜追更党打造的深色主题，柔和光线让51漫画在线观看更舒适。' },
  { date: '2026.07.12', tag: '热门连载', title: '《完美世界》动画联动特别漫画篇发布', desc: '与动画制作组联合推出联动内容，动画粉丝也能在漫画中找到隐藏彩蛋。' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-600">51漫画网每日更新资讯，不错过任何精彩</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200">
            {updates.map((item, idx) => (
              <div key={idx} className="relative mb-10 last:mb-0">
                <span className="absolute -left-[33px] top-1 w-[18px] h-[18px] rounded-full bg-primary-500 border-4 border-background-50"></span>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap pt-1">{item.date}</span>
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                      <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-md text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                    <h3 className="text-base font-medium text-foreground-900 mb-1.5">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}